import React from 'react'
import SidePanelFramework from '@bt-react/components/SidePanelFramework'
import { IconType } from '@bt-react/components/Icon'
import Attachments from '@bt-react/components/Attachments'

export interface AttachmentsPanelProps {
  channelId?: string
  webcastId?: string
  userTimezone?: string
}

const AttachmentsPanel = (props: AttachmentsPanelProps) => {

  return <SidePanelFramework
    icon={IconType.iconName.paperClip}
    title='Attachments'
    dataBdd='side-panel-session-status'
    scrollable={true}
    content={
      <div>
        <Attachments userTimezone={props.userTimezone} webcastId={props.webcastId} channelId={props.channelId} isOpen={true}/>
      </div>
    }
  />

}

export default AttachmentsPanel
